import React, { useEffect, useContext, useState } from 'react';
import { sendFormAnswers } from '../api';
import { OneOffAuthContext } from '../../../components/oneOffAuth/OneOffAuthContext';
import { LoadingSpinner } from '../../../components/Govuk';
import { Link, useHistory } from 'react-router-dom';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { escapeHtmlFromData } from '../utils';
import { STORE_KEY } from '../index';

export const Uploaded = ({ sarData }) => {
  const { clearTokens, validateUser, isOneOffAuthenticated } = useContext(OneOffAuthContext);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [uuid, setUuid] = useState(null);
  const { trackPageView, trackEvent } = useMatomo();
  const history = useHistory();
  sarData = escapeHtmlFromData(sarData);

  useEffect(() => {
    trackPageView({
      documentTitle: 'One-off SAR Uploaded - Report Suspicious Chemical Activity'
    });
    if (!sarData) {
      return;
    }
    if (isOneOffAuthenticated()) {
      validateUser()
        .then(() => performSubmit())
        .catch(() => history.push('/something-went-wrong'));
    } else {
      performSubmit();
    }
  }, [isOneOffAuthenticated]);

  function performSubmit() {
    sendFormAnswers(sarData)
      .then(handleDone);
  }

  function handleDone(res) {
    setFormSubmitted(true);
    // eslint-disable-next-line
    console.log('res: ', res);
    if (!res || !res.data) {
      return;
    }
    setUuid(res.data.guid);
    sessionStorage.removeItem(STORE_KEY);
    if (isOneOffAuthenticated()) {
      clearTokens();
      trackEvent({
        category: 'One-off SAR',
        action: 'Completed',
      });
    } else {
      trackEvent({
        category: 'Registered one-off SAR',
        action: 'Completed',
      });
    }
  }

  return (
    <main className="govuk-main-wrapper" id="content" role="main" tabIndex={0}>
      {formSubmitted ? (
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <div className="govuk-panel govuk-panel--confirmation">
              <h1 className="govuk-panel__title">Report complete</h1>
              <div className="govuk-panel__body">
                <div className="govuk-panel__body govuk-visually-hidden">
                <strong id="data-uuid" data-test="success-uuid">
                  {uuid}
                </strong>
                </div>
              </div>
            </div>
            <div className="govuk-body">
              We have sent you a confirmation email.
            </div>
            <div className="govuk-body">
              <h2 className="govuk-heading-m"> What happens next</h2>
              <p> We've sent your application to the Home Office.</p>
              <p>
                {' '}
                The police may email you if further information is required. Keep any evidence of the incident or suspicious activity for 6 months
              </p>
              <h2 className="govuk-heading-m">For enquiries</h2>
              If you wish to follow up on this report, contact{' '}
              <a className="govuk-link" href="mailto:chemical.reporting@met.police.uk">
                chemical.reporting@met.police.uk
              </a>{' '}
              and quote your Suspicious Activity Report ID.
              <br /> <br />{' '}
              <h2 className="govuk-heading-m"> Feedback</h2>
              We'd appreciate your{' '}
              <Link className="govuk-link" to="/feedback" data-test="feedback-link" target="_blank">
                feedback
              </Link>{' '}
              on this reporting service, so we can continue to improve it.  We ask 2 questions - it’ll take you less than 1 minute. 
              <br /> <br />{' '}
              <Link to="/login" className="govuk-link">
                Return to the home page
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <LoadingSpinner data-test="spinner" alt="Loading results spinner" />
      )}
    </main>
  );
};
